import { render } from "./enrolment-review-popup-buttons.vue?vue&type=template&id=18d29c64&ts=true"
import script from "./enrolment-review-popup-buttons.ts?vue&type=script&lang=ts&external"
export * from "./enrolment-review-popup-buttons.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__